module.exports = __webpack_public_path__ + "img/graphic-header.4b84e45.4b84e450.svg";